import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getInitialLanguage } from "@/lib/language";

import en from "@/locales/en/common.json";
import tr from "@/locales/tr/common.json";
import es from "@/locales/es/common.json";
import fr from "@/locales/fr/common.json";
import de from "@/locales/de/common.json";
  
i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: getInitialLanguage(),
  resources: {
    en: { translation: en },
    tr: { translation: tr },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
